import GroowLoader from "components/Loader/GroowLoader";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { PUBLIC_ROUTES } from "routes/routes";

export default function Index() {
  const router = useRouter();
  useEffect(() => {
    router.replace(PUBLIC_ROUTES.login.path);
  }, []);
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white dark:bg-black">
      <GroowLoader size={300} />
    </div>
  );
}
